"use client"

import React, { Fragment, ReactElement, useState } from "react"
import styles from "./faq.module.scss"
import StyledText from "../../typography/typography-component"
import Image from "next/image"
import classnames from "classnames"
import skColors from "../../../styles/skColors"
import { Faq } from "../../ratgeber/_types"
import { parseRichTextHtml } from "../../utils/parseRichTextHtml"

export interface InternalFaq {type: "internal_faq", value: { question: string, answer: string, answerJSX: ReactElement}}

const FAQ: React.FC<{ faqs: (Faq | InternalFaq)[] }> = (props) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  const isInternalFaq = (item: Faq | InternalFaq): item is InternalFaq =>
    item.type === "internal_faq" && "answerJSX" in item.value

  // Build FAQ data using translations. Keep JSX for entries that need markup.
  const faqData = props.faqs

  return (
    <div key={"faq-section"} className={styles.faqSection}>
      <StyledText key={"faq-headline"} variant={"h2"} color={skColors.turquoise[600]}>
        FAQ
      </StyledText>
      <div key={"faq-container"} className={styles.faqContainer}>
        {faqData.map((item, index) => (
          <Fragment key={`faq-item-${index}`}>
            <div
              key={`${index}-faq-div`}
              style={{
                borderBottom: `2px solid ${skColors.turquoise[300]}`,
              }}
              className={styles.faqItem}
            >
              <button key={`faq-button-${index}`} className={styles.faqQuestion} onClick={() => toggleFAQ(index)}>
                <StyledText key={`question-${index}`} variant={"h4"}>
                  {item.value.question}
                </StyledText>
                <span key={`span-${index}`}>
                  <Image
                    key={`chevron-${index}`}
                    className={classnames(
                      {
                        [styles.chevronRotated]: openIndex === index,
                      },
                      styles.chevron
                    )}
                    src={"/svg/chevron_down.svg"}
                    alt={"chevron down"}
                    width={16}
                    height={16}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </span>
              </button>
            </div>

            <p key={`p-${index}`} className={classnames({ [styles.open]: openIndex === index }, styles.faqAnswer)}>
              {openIndex === index &&
                (isInternalFaq(item) ? (
                  item.value.answerJSX
                ) : (
                  <div className={styles.body}>{parseRichTextHtml(item.value.answer).content}</div>
                ))}
            </p>
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export default FAQ
